const { useDispatch, useSelector } = require("react-redux");
const { useLocation, Navigate } = require("react-router-dom");
const { setUser } = require("store/reducers/auth");

const ProtectedRoute = ({ children }) => {
  const user_str = localStorage.getItem("user");
  const location = useLocation();
  const dispatch = useDispatch();
  var loggedIn = false;
  const auth = useSelector((state) => state.auth);
  if (user_str) {
    const user = JSON.parse(user_str);
    let date = new Date();
    const expiry = new Date(user.refresh_token_expiry);
    if (expiry > date) {
      if (auth) {
        if (auth.user) {
          if (Object.keys(auth.user).length === 0) {
            loggedIn = true;
            dispatch(setUser(user));
          }
        } else {
          loggedIn = false;
          dispatch(setUser(user));
        }
      }
    }
  }

  if (auth.isLoggedIn || loggedIn) {
    const user = JSON.parse(user_str);
    if(user.profile_id){
      return children;
    }else{
      return <Navigate to="/new-user-profile" state={{ from: location }} />;
    }
    
  }

  return <Navigate to="/login" state={{ from: location }} />;
  
};

export default ProtectedRoute;
